module.exports = __webpack_public_path__ + "img/bg2.8aa13e55.png";